import YourBeneficiaries from './YourBeneficiaries';
import { getAllProfiles } from '../../../../services/profiles';
import { Container } from 'react-bootstrap';

const YourBeneficiariesDemo = () => {
  const profiles = getAllProfiles().data.filter(
    (profile) => profile.relationship !== 'self'
  );

  const handleDelete = () => {
    console.log('Open delete modal');
  };

  const handleEdit = () => {
    console.log('Open edit modal');
  };

  return (
    <Container>
      <h4>Your Beneficiaries Widget</h4>
      <YourBeneficiaries
        handleDelete={handleDelete}
        handleEdit={handleEdit}
        data={profiles}
      />
    </Container>
  );
};

export default YourBeneficiariesDemo;
